var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "nativewind/jsx-runtime";
import EmptyViewText from '@/components/empty/EmptyViewText';
import { ScreenLayout } from '@/components/ScreenLayout';
import TabBar from '@/components/TabBar';
import useAppComponents from '@/hooks/useAppComponents';
import { FlashList } from '@shopify/flash-list';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import AchievementsSection from '../ConquererHistoryScreen/sections/AchievementsSection';
import ReviewHistoryPlaceReviewItem from './components/PlaceReviewItem';
import ReviewHistoryPlaceToiletReviewItem from './components/PlaceToiletReviewItem';
import { tabItems } from './constants';
// 내가 작성한 리뷰
export default function ReviewHistoryScreen() {
    var _a, _b;
    const insets = useSafeAreaInsets();
    const { api } = useAppComponents();
    const [currentTab, setCurrentTab] = useState('PLACE_REVIEW');
    const { data, fetchNextPage, hasNextPage, isFetchingNextPage } = useInfiniteQuery({
        queryKey: ['MyReviews', currentTab],
        queryFn: (_a) => __awaiter(this, [_a], void 0, function* ({ pageParam }) {
            if (currentTab === 'PLACE_REVIEW') {
                return (yield api.listRegisteredPlaceReviewsPost({
                    nextToken: pageParam,
                    limit: 20,
                })).data;
            }
            else {
                return (yield api.listRegisteredToiletReviewsPost({
                    nextToken: pageParam,
                    limit: 20,
                })).data;
            }
        }),
        getNextPageParam: lastPage => {
            return lastPage.nextToken;
        },
        initialPageParam: undefined,
    });
    const totalNumberOfReviews = (_a = data === null || data === void 0 ? void 0 : data.pages[0].totalNumberOfItems) !== null && _a !== void 0 ? _a : 0;
    return (_jsxs(ScreenLayout, { isHeaderVisible: true, children: [_jsx(TabBar, { items: tabItems, current: currentTab, onChange: setCurrentTab }), _jsx(FlashList, { contentContainerStyle: {
                    paddingBottom: insets.bottom,
                }, data: (_b = data === null || data === void 0 ? void 0 : data.pages.flatMap(page => {
                    if (currentTab === 'PLACE_REVIEW') {
                        return page.placeReviews;
                    }
                    else {
                        return page.toiletReviews;
                    }
                })) !== null && _b !== void 0 ? _b : [], renderItem: ({ item }) => {
                    if (currentTab === 'PLACE_REVIEW') {
                        return (_jsxs(_Fragment, { children: [_jsx(View, { className: "p-5 gap-4", children: _jsx(ReviewHistoryPlaceReviewItem, { placeId: item.placeId, review: item }) }), _jsx(View, { className: "h-[1px] bg-gray-20" })] }));
                    }
                    else {
                        return (_jsxs(_Fragment, { children: [_jsx(View, { className: "p-5 gap-4", children: _jsx(ReviewHistoryPlaceToiletReviewItem, { placeId: item.placeId, review: item }) }), _jsx(View, { className: "h-[1px] bg-gray-20" })] }));
                    }
                }, onEndReached: () => {
                    if (hasNextPage && !isFetchingNextPage) {
                        fetchNextPage();
                    }
                }, onEndReachedThreshold: 0.5, ListHeaderComponent: _jsx(AchievementsSection, { type: "review", totalNumberOfPlaces: totalNumberOfReviews }), ListEmptyComponent: _jsx(EmptyViewText, {}) })] }));
}
